import BerichtStandardCharts from "./BerichtStandardCharts/BerichtStandardCharts.vue";

export default {
  BerichtStandardCharts,
};
